export default "/biometrie-afghanistan/media/f4e1b5057e4482add095e691bee4c68f~scanner.jpg";